import axios from 'axios';
import { backendHost } from '../../config';

export const postConfirmationPhone = (params) => {
    return axios.post(`${backendHost}/api/client/confirmation/phone/update`, params);
};